// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"on_a bhk_qr bhk_a bhk_w","FaqAskQuestion__outdated":"on_b bhk_vp bhk_xe"};